import { render, staticRenderFns } from "./NewProductForm.vue?vue&type=template&id=dce1cdd0&scoped=true"
import script from "./NewProductForm.vue?vue&type=script&lang=js"
export * from "./NewProductForm.vue?vue&type=script&lang=js"
import style0 from "./NewProductForm.vue?vue&type=style&index=0&id=dce1cdd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce1cdd0",
  null
  
)

export default component.exports